/** El chip de una cita: número, foco propio y vista previa.
 *
 * Patrón de las referencias de 2026 (Perplexity, ChatGPT Deep Research): la cita es un elemento
 * FOCUSABLE de verdad, numerado igual que la tarjeta del panel, con una previa al pasar por
 * encima y apertura al tocar. Un `<span>` con hover no sirve: en táctil no hay hover, y con
 * teclado no se llega.
 */
import { useState } from "react";
import type { Idioma, Tarjeta } from "../lib/tipos";
import { bi, t } from "../lib/i18n";

const MAX_PREVIA = 200;

export function ChipCita({ n, tarjeta, idioma, activa, alAbrir }: {
  n: string; tarjeta: Tarjeta | undefined; idioma: Idioma; activa: boolean; alAbrir: () => void;
}) {
  const txt = t(idioma);
  const [previa, setPrevia] = useState(false);
  if (!tarjeta) return <span className="cita huerfana" title={txt.sinDatos}>{n}</span>;

  const extracto = (bi(tarjeta.frases[0], idioma) || bi(tarjeta.limite, idioma) || "").slice(0, MAX_PREVIA);
  return (
    <span className="cita-envoltura">
      <button
        className={`cita${activa ? " activa" : ""}`}
        onClick={alAbrir}
        onMouseEnter={() => setPrevia(true)}
        onMouseLeave={() => setPrevia(false)}
        onFocus={() => setPrevia(true)}
        onBlur={() => setPrevia(false)}
        onKeyDown={(e) => { if (e.key === "Escape") setPrevia(false); }}
        aria-label={`${txt.evidencia} ${n}: ${bi(tarjeta.titulo, idioma)}`}
      >
        {n}
      </button>
      {previa && (
        <span className="cita-previa" role="tooltip">
          <strong>{bi(tarjeta.titulo, idioma)}</strong>
          <em>{tarjeta.fuentes.map((f) => bi(f.nombre, idioma)).join(" · ")}</em>
          {extracto && <span>{extracto}{extracto.length >= MAX_PREVIA ? "…" : ""}</span>}
          <span className={`chip nivel-${tarjeta.nivel}`}>{txt.niveles[tarjeta.nivel]}</span>
        </span>
      )}
    </span>
  );
}
